import { useEffect, useMemo } from 'react'
import { getOptionsConfig } from '@rawgraphs/rawgraphs-core'
import {
  getPreviewSizeDimensions,
  PREVIEW_SIZE_PRESETS,
} from '../services/previewSizing'
import { getPreviewRendererMode } from '../services/previewRendererMode'

export { PREVIEW_SIZE_PRESETS }

export default function usePreviewSizing({
  currentChart,
  data,
  mapping,
  previewSizePreset,
  previewCustomSize,
  largeDatasetInfo,
  setVisualOptions,
}) {
  const previewRendererMode = useMemo(
    () => getPreviewRendererMode(currentChart, largeDatasetInfo.rowCount),
    [currentChart, largeDatasetInfo.rowCount]
  )

  const previewDimensions = useMemo(
    () =>
      getPreviewSizeDimensions({
        chart: currentChart,
        dataset: data?.dataset,
        mapping,
        dataTypes: data?.dataTypes,
        preset: previewSizePreset,
        customDimensions: previewCustomSize,
      }),
    [currentChart, data, mapping, previewSizePreset, previewCustomSize]
  )

  useEffect(() => {
    if (!currentChart?.visualOptions) {
      return
    }

    const optionsConfig = getOptionsConfig(currentChart.visualOptions)
    if (!optionsConfig.width && !optionsConfig.height) {
      return
    }

    setVisualOptions((prev) => {
      const next = { ...prev }
      let changed = false

      if (optionsConfig.width && prev.width !== previewDimensions.width) {
        next.width = previewDimensions.width
        changed = true
      }

      if (optionsConfig.height && prev.height !== previewDimensions.height) {
        next.height = previewDimensions.height
        changed = true
      }

      return changed ? next : prev
    })
  }, [currentChart, previewDimensions, setVisualOptions])

  return {
    previewRendererMode,
    previewDimensions,
  }
}
